@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;
@use '@hevoio/hevo-ui-toolkit/styles/mixins' as hevo-toolkit-mixins;

.dropdownTrigger {
  $horizontal-gutter:  hevo-toolkit-variables.$spacer * 0.5;
  $vertical-gutter:  hevo-toolkit-variables.$spacer * 0.25;

  @include  hevo-toolkit-mixins.clear-btn-style();
  display: inline-flex;
  padding: $vertical-gutter $horizontal-gutter;
  cursor: pointer;
  border-radius:  hevo-toolkit-variables.$border-radius-default;
  background-color: inherit;
  align-items: center;
  font-weight:  hevo-toolkit-variables.$font-weight-medium;

  &:focus:not(.disabled):not(.clearSurroundingGutter),
  &:hover:not(.disabled):not(.clearSurroundingGutter) {
    background-color:  hevo-toolkit-variables.$menu-active-bg;
  }

  .icon {
    margin-left:  hevo-toolkit-variables.$spacer * 0.25;
    font-size:  hevo-toolkit-variables.$icon-size-base * 0.875;
  }

  .thumbnail {
    margin-right:  hevo-toolkit-variables.$spacer;
    font-size:  hevo-toolkit-variables.$icon-size-base;
  }

  &.disabled {
    cursor: default;

    .icon {
      opacity: 0;
      transform: scale(0);
    }
  }

  &.clearHorizontalGutter {
    margin-left: -$horizontal-gutter;
    margin-right: -$horizontal-gutter;
  }

  &.clearSurroundingGutter {
    margin: -1 * $vertical-gutter -1 * $horizontal-gutter;
  }
}
